module.exports = __webpack_public_path__ + "static/media/white_logo_png.f2d47e57.png";